import "jquery/dist/jquery.min.js";
import Endpoints from "@/config/ApiEndpoints.js";
import Swiper, {navigation} from 'swiper';
var moment = require("moment");

export default {
  	props: ["AssetsList"],
    components: { 
    },
    filters: {
		date: function (data) {
		var sendDate = "N/A";
		if (data != "" && data != null) {
			sendDate = moment(data).format("DD-MM-YYYY");
		}
		return sendDate;
		},
	},
    data() {
      return {     
		ShowVehicleAssetsModel:false,   
		VehicleImageEndpoint: Endpoints.Helper.GenerateImage+ '/',
      };
    },   
    mounted() {      
    },
    computed: {    	   		
  	},
    methods: {    
		ShowVehicleAssetPopup(){
			this.ShowVehicleAssetsModel = true;
			setTimeout(() => {
				new Swiper('.swiper', {
					// Optional parameters
					direction: 'horizontal',
					loop: this.vehicleLoop,
					// Navigation arrows
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					});
			}, 1000);
		}
    },
  };
